import { Grid, FormControl, FormLabel, Button, Typography, Container } from "@mui/material";
import { ConfirmPopup, Icon } from "components";
import { theme } from "config";
import { t } from "i18next";
import { observer } from "mobx-react";
import { Course } from "models";
import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { StepFilesModal } from "./stepFilesModal";


export interface IAddThumbnailProps {
  course: Course
}

export const AddThumbnail = observer((props: IAddThumbnailProps) => {
  const { course } = props;
  const { t } = useTranslation();

  const [showFileModal,    setShowFileModal]    = React.useState<boolean>(false);
  const [openConfirmPopup, setOpenConfirmPopup] = React.useState<boolean>(false);

  return (
    <Grid xs={12} item mt={4} mb={3} className="addThumbnail">
        <FormControl>
          <FormLabel id='filled-basic'>{t('image')}</FormLabel>
          <div style={{display: "flex", alignItems: "center"}}>
            <Button
              onClick   = {() => setShowFileModal(true)}
              variant   = 'contained'
              startIcon = {<Icon iconId='add' />}
            >
              {t('add_image')}
            </Button>
            {course.getCurStep.thumbnail &&
              <>
                <Typography
                  sx            = {{ marginLeft: "24px", marginRight: "8px" }}
                  variant       = 'subtitle2'
                  color         = {theme.palette.black.main}
                >
                  {course.getCurStep.thumbnail.title || ""}
                </Typography>
                <ConfirmPopup
                  placement = 'right'
                  onClose   = {() => setOpenConfirmPopup(false)}
                  open      = {openConfirmPopup}
                  onConfirm = {() => {
                    course.getCurStep.removeDocument(course.getCurStep.thumbnail);
                  }}
                  onCancel  = {() => setOpenConfirmPopup(false)}
                >
                  <DeleteIcon
                    iconId  = 'bin'
                    onClick = {() => {
                      setOpenConfirmPopup(true)
                    }}
                  />
                </ConfirmPopup>
              </>
            }
          </div>
        </FormControl>
        <StepFilesModal
          isOpen      = {showFileModal}
          targetStep  = {course.getCurStep}
          onClose     = {() => setShowFileModal(false)}
          isThumbnail = {true}
        />
    </Grid>
  );
});


const DeleteIcon = styled(Icon)`
  transition: opacity 0.2s ease;
  cursor:     pointer;
`